import type { Term } from '../systems/EventBus';

export interface QuizQuestion {
  term: Term;
  prompt: string;
  options: readonly string[];
  /** Index into options[] of the correct answer. */
  correctIndex: number;
}

/** 8-question multiple choice quiz, one per core term. Each question
 *  tests recall of the *function* of the term, not the literal definition. */
export const VOCAB_QUIZ: readonly QuizQuestion[] = [
  {
    term: 'aging-bucket',
    prompt: "Which 'aging bucket' is the most concerning for cash flow?",
    options: ['0-30 days', '31-60 days', '61-90 days', '90+ days'],
    correctIndex: 3,
  },
  {
    term: 'dunning',
    prompt: "A customer is 75 days past due. Which dunning level fits best?",
    options: ['1st Notice', 'Past Due', 'Final Notice', 'Collections Referral'],
    correctIndex: 2,
  },
  {
    term: 'cash-application',
    prompt: "What's the biggest risk during cash application?",
    options: [
      'Applying too quickly',
      'Applying to the wrong customer',
      'Forgetting to send a confirmation',
      'Sending a thank-you email',
    ],
    correctIndex: 1,
  },
  {
    term: 'short-pay',
    prompt: "A customer pays $4,200 on a $5,000 invoice. The smartest first move is to:",
    options: [
      'Apply $4,200 and immediately write off the rest',
      'Reject the payment outright',
      'Pause and check if a credit memo or dispute is in flight',
      'Email the CFO',
    ],
    correctIndex: 2,
  },
  {
    term: 'dispute',
    prompt: "When you log a dispute, the most important thing to capture is:",
    options: [
      'The exact invoice number',
      'The customer\'s mood',
      'The current weather',
      'Your gut feeling',
    ],
    correctIndex: 0,
  },
  {
    term: 'promise-to-pay',
    prompt: "A real promise-to-pay always includes:",
    options: [
      'A polite tone',
      'A specific amount AND date',
      'A signed contract',
      'CFO approval',
    ],
    correctIndex: 1,
  },
  {
    term: 'write-off',
    prompt: "When you write off an invoice, the amount becomes:",
    options: [
      'A tax credit',
      'Bad debt on the P&L',
      'Customer goodwill',
      'A future receivable',
    ],
    correctIndex: 1,
  },
  {
    term: 'dso',
    prompt: "DSO measures…",
    options: [
      'Daily sales output',
      'Days sales outstanding — how long invoices sit unpaid',
      'Distinct shipping orders',
      'Disputed sales originated',
    ],
    correctIndex: 1,
  },
];
